import { UserFormInterface, ValidationSet } from '../../../../types/interface';
import { commonValidations } from '../validations';

export const UserFormValidationSet: ValidationSet<UserFormInterface> = {
  firstName: commonValidations.firstName,
  lastName: commonValidations.lastName,
  role_id: commonValidations.role_id,
  user_type: commonValidations.type,
  email: commonValidations.email,
  password: commonValidations.password,
  group_ids: commonValidations.state_admin_level_group
};
